import moment from 'moment'
export default function webSocketPlugin () {
  return store => {
    setTimeout(initSocket(store), 1000)
  }
}
let socket = null
function initSocket (store) {
  return () => {
    if (!store.state.auth.loggedIn) {
      setTimeout(initSocket(store), 1000)
      if (socket) {
        socket.close()
        socket = null
      }
      return
    }
    socket = new WebSocket(
      `${store.getters['app/wsUrl']}/ws?token=${store.state.auth.authToken}`
    )
    store.subscribe(mutation => {
      if (mutation.type === 'call/call') {
        console.log('----------->', mutation)
        socket.send(
          JSON.stringify({
            type: 'Call',
            request_id: store.getters['call/requestId'],
            payload: {
              chat_space_id: store.getters['call/chatId'],
              type: store.getters['call/type']
            }
          })
        )
      } else if (mutation.type === 'call/finish') {
        console.log('----------->', mutation)
        socket.send(
          JSON.stringify({
            type: 'FinishCall',
            request_id: store.getters['call/requestId'],
            payload: {
              call_id: store.getters['call/callId']
            }
          })
        )
      } else if (mutation.type === 'call/decline') {
        console.log('----------->', mutation)
        socket.send(
          JSON.stringify({
            type: 'DeclineCall',
            request_id: store.getters['call/requestId'],
            payload: {
              call_id: store.getters['call/callId']
            }
          })
        )
      } else if (mutation.type === 'call/answer') {
        console.log('----------->', mutation)
        socket.send(
          JSON.stringify({
            type: 'AnswerCall',
            request_id: store.getters['call/requestId'],
            payload: {
              call_id: store.getters['call/callId']
            }
          })
        )
      }
    })

    socket.onclose = event => {
      // store.commit('alert/setAlert', {
      //   message: 'Socket stoped working',
      //   type: 'danger'
      // })
      // console.error(error)
      // window.location.reload()
      setTimeout(initSocket(store), 5000)
    }
    socket.onerror = error => {
      console.error(error)
      // store.commit('alert/setAlert', {
      //   message: error.message,
      //   type: 'danger'
      // })
      setTimeout(initSocket(store), 5000)
    }
    socket.onmessage = data => {
      const message = JSON.parse(data.data)
      switch (message.type) {
        case 'PatientCaseEvidenceAdded':
        case 'PatientCaseEvidenceEdited':
          store.commit('pcase/setEvidence', { id: message.payload.patient_case_id, evidence: message.payload.data })
          break
        case 'PatientCaseEvidenceRemoved':
          store.commit('pcase/removeEvidence', { id: message.payload.patient_case_id, evidenceId: message.payload.evidence_id })
          break
        case 'TreatmentItemCreated':
        case 'TreatmentItemCancelled':
          store.commit('pcase/setTreatement', { id: message.payload.data.patient_case_id, evidenceId: message.payload.data })
          break
        case 'ServiceRequestCreated':
        case 'ServiceRequestCancelled':
        case 'ServiceRequestFulfilled':
        case 'ServiceRequestFailed':
        case 'ServiceRequestReactivated':
          store.commit('pcase/setServiceRequest', { id: message.payload.data.patient_case_id, serviceRequest: message.payload.data })
          break
        case 'PatientCaseLabtestAdded':
        case 'PatientCaseLabtestEdited':
          store.commit('pcase/setLabtest', { id: message.payload.patient_case_id, labtest: message.payload.data })
          break
        case 'PatientCaseLabtestRemoved':
          store.commit('pcase/removeLabtest', { id: message.payload.patient_case_id, labtestId: message.payload.id })
          break
        case 'ScheduleActivated':
        case 'ScheduleCompleted':
          store.commit('panel/remove', message.payload.data.id)
          setSchedule(store, message.payload.data)
          break
        case 'ScheduleCreated':
        case 'Schedulestart_timeUpdated':
        case 'ScheduleGotPending':
        case 'ScheduleCancelled':
        case 'ScheduleInterviewBound':
        case 'ScheduleInterviewActivated':
        case 'ScheduleInterviewFinished':
          setSchedule(store, message.payload.data)
          break
        case 'PatientCaseFileUploaded':
          store.commit('pcase/pushFile', { id: message.payload.patient_case_id, file: message.payload.data })
          break
        case 'PatientCaseFileDeleted':
          store.commit('pcase/removeFile', { id: message.payload.patient_case_id, file: message.payload.id })
          break
        case 'NotificationCreated':
          NotificationCreated(store, message.payload)
          break
        case 'PatientCaseCreated':
          if (message.payload.data.patient_id === store.getters['panel/patient_id'] && message.payload.data.assignee_id === store.getters['panel/doctor_id']) {
            let component = (message.payload.data.status === 'active' ? 'patient-case-edit' : 'patient-case')
            if (store.getters['auth/type'] === 'Patient') {
              component = 'patient-case'
            }
            store.commit('panel/push', {
              id: message.payload.data.id,
              title: moment(message.payload.data.start_time).format('DD MMMM YYYY'),
              component: component,
              date: message.payload.data.start_time
            })
          }
          setCase(store, message.payload.data)
          break
        case 'PatientCaseCompleted':
        case 'PatientCaseCancelled':
        case 'PatientCaseCommentUpdated':
        case 'PatientCaseConclusionUpdated':
          setCase(store, message.payload.data)
          break
        case 'ClinicInquiryCreated':
        case 'ClinicInquiryJoined':
        case 'ClinicInquiryCompleted':
          store.commit('chat/setInquiry', { id: message.payload.data.patient_clinic_chat_id, inquiry: message.payload.data })
          break
        case 'UserStatusChange':
          UserStatusChange(store, message.payload)
          break
        case 'MessageCreated':
          MessageCreated(store, message.payload)
          break
        case 'Call':
        case 'AnswerCall':
        case 'FinishCall':
          Call(
            store,
            message.request_id,
            message.response_type,
            message.payload
          )
          break
        case 'DeclineCall':
          DeclineCall(
            store,
            message.request_id,
            message.response_type,
            message.payload
          )
          break
        case 'CallUpdated':
          CallUpdate(store, message.payload)
          break
        case 'CallIncame':
          CallIncame(store, message.payload)
          break
      }
      console.log('-->>', message)
    }
  }
}

function setSchedule (store, schedule) {
  store.commit('schedule/set', {
    id: schedule.id,
    city_id: schedule.city_id,
    address: schedule.address,
    patient_id: schedule.patient_id,
    patient: schedule.patient,
    clinic_service_id: schedule.clinic_service_id,
    clinic_service: schedule.clinic_service,
    clinic_id: schedule.clinic_id,
    service_id: schedule.service_id,
    assignee_id: schedule.assignee_id,
    assignee: schedule.assignee,
    communication_days: schedule.communication_days,
    start_time: schedule.start_time,
    status: schedule.status,
    price: schedule.price,
    comment: schedule.comment,
    interview_id: schedule.interview_id,
    interview_status: schedule.interview_status,
    patient_case_id: schedule.patient_case_id,
    created_at: schedule.created_at,
    created_by: schedule.created_by
  })
}
function NotificationCreated (store, payload) {
  store.commit('notification/set', [payload.data])
  store.commit('app/setNewNotification', payload.data)
}
function setCase (store, c) {
  store.commit('pcase/set', c)
}

function CallUpdate (store, payload) {
  if (!payload || !payload.data) {
    store.commit('alert/setAlert', {
      message: 'Call update failed',
      type: 'danger'
    })
    return
  }
  store.commit('call/setExpiration', payload.data.expires_at)
  store.commit('call/setStatus', payload.data.status)
}
function CallIncame (store, payload) {
  store.commit('call/incoming', {
    callId: payload.data.id,
    caller: payload.data.caller_id,
    chatId: payload.data.chat_space_id,
    status: payload.data.status,
    expiresAt: payload.data.expires_at
  })
}
function Call (store, requestId, responseType, payload) {
  const myRequestId = store.getters['call/requestId']
  if (responseType !== 'Ok' || !requestId || myRequestId !== requestId) {
    store.commit('alert/setAlert', {
      message: 'Could not call',
      type: 'danger'
    })
    return
  }
  store.commit('call/setStatus', payload.status)
  store.commit('call/setCallId', payload.id)
  store.commit('call/setCallerId', null)
  console.log('calling', requestId, responseType, payload)
}
function DeclineCall (store, requestId, responseType, payload) {
  const myRequestId = store.getters['call/requestId']
  if (responseType !== 'Ok' || !requestId || myRequestId !== requestId) {
    store.commit('alert/setAlert', {
      message: 'Could not call',
      type: 'danger'
    })
    return
  }
  store.commit('call/reset')
  console.log('calling', requestId, responseType, payload)
}

function UserStatusChange (store, payload) {
  store.commit('status/push', {
    userId: payload.user_id,
    status: payload.status
  })
}

function MessageCreated (store, payload) {
  const message = payload.data
  // const currentChatId = store.getters['app/chatId']

  // const loading = store.getters['chat/isLoading']
  // if (loading) {
  //   setTimeout(() => {
  //     MessageCreated(store, payload)
  //   }, 1000)
  //   return
  // }
  const chatId = store.getters['message/chatId']
  if (chatId === message.chat_space_id) {
    store.commit('message/push', message)
  }
  const chat = store.getters['chat/byId'](message.chat_space_id)
  if (!chat) {
    store.dispatch('chat/fetchChat', message.chat_space_id)
  } else {
    store.commit('chat/replaceMessage', message)
  }
  store.commit('app/setNewMessage', message)
}
